import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import Strings from "../../utils/stringUtil";
import AppIcons from "../../utils/appIcons";
import { isMobile } from "../../utils/responsiveUtil";
import styles from "../../assets/styles/main.module.css";
import productStyle from "../../assets/styles/product.module.css";
import theme from "../../utils/themeUtil";
import TextSize from "../../utils/textSizeUtil";
import { Link } from "react-router-dom";
import Routes from "../../utils/routesUtil";

function ServiceBox({ to, image, title, imgHeight, imgWidth }) {
  function renderBox() {
    return (
      <Box
        bgcolor={theme.palette.white.main}
        mt={isMobile ? 2 : 0}
        boxShadow={3}
        borderRadius={4}
        textAlign="center"
      >
        <Box py={3}>
          <img
            src={image}
            alt={title}
            width={imgWidth || "60px"}
            height={imgHeight || "auto"}
          />
        </Box>
        <Box
          bgcolor={theme.palette.lightGreen.main}
          p={2}
          color={theme.palette.white.main}
          style={{
            borderBottomLeftRadius: "10px",
            borderBottomRightRadius: "10px",
            fontSize: TextSize.size18,
          }}
        >
          <Typography style={{ fontSize: TextSize.size18, fontWeight: "500" }}>
            {title}
          </Typography>
        </Box>
      </Box>
    );
  }
  return to ? (
    <Link to={to} style={{ textDecoration: "none" }}>
      {renderBox()}
    </Link>
  ) : (
    <Box>{renderBox()}</Box>
  );
}

function Intro() {
  return (
    <React.Fragment>
      <Box className={productStyle.mainBg}>
        <Box className={styles.container}>
          <Grid container alignItems="center">
            <Grid item xs={12} md={12} style={{ textAlign: "center" }}>
              <Box mt={isMobile ? 2 : 6} px={isMobile ? 2 : 16}>
                <Typography
                  style={{
                    fontSize: isMobile ? TextSize.size24 : TextSize.size36,
                    fontWeight: "600",
                  }}
                >
                  {Strings.financialProductsAndServices}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Box mt={isMobile ? 2 : 6.5} px={isMobile ? 2 : 29}>
            <Grid container alignItems="center" justifyContent={'center'} spacing={3}>
              <Grid
                item
                xs={12}
                md={6}
                style={{ textAlign: isMobile ? "center" : "left" }}
              >
                <ServiceBox
                  to={Routes.MAHILA_LOAN}
                  image={AppIcons.imgMoneyBag}
                  title={Strings.mahilaMoneyLoans}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
}

export default Intro;
